import { useRouteMatch } from 'react-router';

import { TopPanel } from '../../components';
import { MessagesList } from './MessagesList';
import { Button, Input } from '../../components';
import { useMessagesForContact } from './useMessagesForContact';

type MessagesForContactComponentProps = {
  contactId: string;
};

const MessagesForContactComponent: React.FC<
  MessagesForContactComponentProps
> = ({ contactId }) => {
  const {
    nodes,
    refresh,
    sending,

    chat,
    setChat,
    sendChat,
    reloading,
    initializing,

    contact,
  } = useMessagesForContact(contactId);

  return (
    <div className="flex flex-col gap-y-md w-full">
      <TopPanel>
        {!!contact && (
          <div className="mr-auto flex items-center font-medium text-big truncate">
            {[contact.first_name, contact.last_name].filter(Boolean).join(' ')}
          </div>
        )}

        <Button icon="refresh" loading={reloading} onClick={refresh}>
          Refresh
        </Button>
      </TopPanel>

      <MessagesList initializing={initializing} data={nodes} />
      <div className="flex gap-md items-center relative">
        <Input
          multiline
          rows={3}
          value={chat}
          onChange={setChat}
          disabled={!contact || sending}
          placeholder="Type your message as a human representative..."
        />
        <Button
          icon="send"
          className="h-fit"
          loading={sending}
          onClick={sendChat}
          disabled={!chat.trim().length || !contact}
        />
      </div>
    </div>
  );
};

const MessagesForContact = () => {
  const {
    params: { id },
  } = useRouteMatch<{ id: string }>();

  return id ? <MessagesForContactComponent contactId={id} /> : null;
};

export default MessagesForContact;
